import clsx from "clsx";
import * as React from "react";

interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: React.CSSProperties["flexDirection"];
  wrap?: React.CSSProperties["flexWrap"];
  justify?: React.CSSProperties["justifyContent"];
  align?: React.CSSProperties["alignItems"];
  gap?: React.CSSProperties["gap"];
}

const Flex = React.forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  const {
    direction = "row",
    wrap = "nowrap",
    justify = "flex-start",
    align = "stretch",
    gap,
    className,
    style,
    ...rest
  } = props;
  return (
    <div
      ref={ref}
      style={{
        display: "flex",
        flexDirection: direction,
        flexWrap: wrap,
        justifyContent: justify,
        alignItems: align,
        gap: gap,
        ...style,
      }}
      className={clsx("ox-reset ox-Flex", className)}
      {...rest}
    />
  );
});

Flex.displayName = "Flex";
export { Flex };
export type { FlexProps };
